import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';

import servicioFormatos from '../../servicios/ServicioFormatos';
import sevicioHttp from '../../servicios/InterceptorAxios';

export const TablaTickets = (props) => {

    const { cruces, urlEliminarCruces, funcionBusquedaNru } = props;
    const [calculos, setCalculos] = useState({});
    const [elNru, setElNru] = useState({});
    const [mostrarModal, setMostrarModal] = useState(false);

    useEffect(() => {
        realizarSumatorias();
    }, [cruces]);

    const templateBorrarCruce = (rowData, column) => {
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-warning" onClick={(e) => mostrarEliminarNru(rowData)}></Button>
        </div>;
    }

    const templateColumnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fecha)}</div>;
    }

    const templateColumnaImporte = (rowData, column) => {
        return <div>{servicioFormatos.formatearModena(rowData.importe)}</div>;
    }

    const mostrarEliminarNru = (rowData) => {
        setElNru(rowData);
        setMostrarModal(true);
    }

    const realizarSumatorias = () => {
        const losCalculos = { subTotal: 0, iva: 0, total: 0 };
        for (var i = 0; i < cruces.length; i++) {
            var nru = cruces[i];
            losCalculos.subTotal = losCalculos.subTotal + nru.tarifa;
            losCalculos.iva = losCalculos.iva + nru.iva;
            losCalculos.total = losCalculos.total + nru.importe;
        }
        setCalculos(losCalculos);
    }

    const cerrarModal = () => {
        setMostrarModal(false);
    }

    const borrarNru = () => {
        sevicioHttp.post(urlEliminarCruces, { id: elNru.id }).then(response => {
            cerrarModal();
            funcionBusquedaNru();
        }).catch(error => {

        });
    }

    const piePaginaModalEliminar = (
        <div>
            <Button label="Si" icon="pi pi-check" onClick={borrarNru} />
            <Button label="No" icon="pi pi-times" onClick={cerrarModal} className="p-button-secondary" />
        </div>
    );

    return (<div>
        <Dialog header="¿Eliminar NRU?" visible={mostrarModal} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalEliminar} onHide={cerrarModal}>
            Esta usted seguro de eliminar el NRU {elNru.nru} ?
        </Dialog>



        <DataTable value={cruces} header="Conceptos agregados" responsive={true}>
            <Column body={templateBorrarCruce} style={{ textAlign: 'center', width: '8em' }} />
            <Column field="nru" header="NRU" />
            <Column body={templateColumnaFecha} header="Fecha" />
            <Column body={templateColumnaImporte} header="Importe" style={{ textAlign: 'center' }} />
        </DataTable>
        <div className="p-grid">
            <div className="p-col-12 p-md-12">
                {cruces.length > 0 ? <Panel header="" style={{ height: '100%' }}>
                    <div className="activity-header">
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span style={{ fontWeight: 'bold' }}>({cruces.length}) NRU(s) agregado(s)</span>
                            </div>
                        </div>
                    </div>

                    <div className="activity-header">
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span style={{ fontWeight: 'bold' }}>Sub-total: </span>{servicioFormatos.formatearModena(calculos.subTotal)}
                            </div>
                        </div>
                    </div>

                    <div className="activity-header">
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span style={{ fontWeight: 'bold' }}>IVA: </span>{servicioFormatos.formatearModena(calculos.iva)}
                            </div>
                        </div>
                    </div>

                    <div className="activity-header">
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span style={{ fontWeight: 'bold' }}>Total: </span>{servicioFormatos.formatearModena(calculos.total)}
                            </div>
                        </div>
                    </div>
                </Panel> : null}
            </div>
        </div>
    </div>);
}